module.exports = __webpack_public_path__ + "img/ch6pic2.49df5271.png";